import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import { loadingButtonClasses as classes } from './loadingButtonClasses';
import { LoadingButtonRoot } from './LoadingButton.style';

const LoadingButton = forwardRef(
  ({ loading, variant, children, CircularProgressProps, ...rest }, ref) => {
    return (
      <LoadingButtonRoot
        ref={ref}
        variant={variant}
        loading={loading}
        {...rest}>
        <div className={classes.buttonContent}>{children}</div>
        {loading && <CircularProgress size={17} {...CircularProgressProps} />}
      </LoadingButtonRoot>
    );
  }
);

LoadingButton.propTypes = {
  'aria-label': PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  loading: PropTypes.bool,
  /**
   * props available in Material's [CircularProgress](https://mui.com/material-ui/api/circular-progress) component
   */
  CircularProgressProps: PropTypes.object
};

LoadingButton.classes = classes;
LoadingButton.displayName = 'LoadingButton';

export default LoadingButton;
